


























































































import { Component, Vue, Prop } from 'vue-property-decorator';
import quotationServices from '@/services/quotation-services';

@Component
export default class ImportGoodsModal extends Vue {
    @Prop({ default: false })
    private visible!: boolean;

    @Prop({ required: true })
    private quotationId!: number | string;

    private selectedFile: File | null = null;
    private isDragging: boolean = false;
    private isUploading: boolean = false;
    private uploadProgress: boolean = false;

    private triggerFileInput() {
        if (this.isUploading) return;
        const input = this.$refs.fileInput as HTMLInputElement;
        if (input) {
            input.value = '';
            input.click();
        }
    }

    private onFileChange(e: Event) {
        const target = e.target as HTMLInputElement;
        if (target && target.files && target.files.length > 0) {
            this.handleFile(target.files[0]);
        }
    }

    private onDragOver() {
        this.isDragging = true;
    }

    private onDragLeave() {
        this.isDragging = false;
    }

    private onDrop(e: DragEvent) {
        this.isDragging = false;
        if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            this.handleFile(e.dataTransfer.files[0]);
        }
    }

    private handleFile(file: File) {
        const parts = file.name.split('.');
        const lastPart = parts.length > 1 ? parts[parts.length - 1] : '';
        const ext = (lastPart || '').toLowerCase();
        if (ext !== 'xlsx' && ext !== 'xls') {
            Vue.notify({
                group: 'foo',
                type: 'error',
                title: 'Sai định dạng file!',
                text: 'Chỉ chấp nhận file định dạng Excel (.xlsx, .xls)'
            });
            return;
        }
        this.selectedFile = file;
    }

    private clearFile() {
        this.selectedFile = null;
    }

    private formatFileSize(bytes: number): string {
        if (!bytes) return '0 B';
        const k = 1024;
        const sizes = ['B', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    }

    private close() {
        if (this.isUploading) return;
        this.clearFile();
        this.$emit('close');
    }

    private async uploadFile() {
        if (!this.selectedFile) return;

        this.isUploading = true;
        this.uploadProgress = true;
        try {
            const res: any = await quotationServices.importGoods(this.quotationId, this.selectedFile);
            if (res && res.data && res.data.status === 200) {
                const resData = res.data && res.data.data;
                const count = (resData && (resData.imported_count || resData.count)) || 0;
                Vue.notify({
                    group: 'foo',
                    type: 'success',
                    title: 'Import thành công!',
                    text: `Đã nhập dữ liệu ${count ? count + ' ' : ''}mặt hàng vào báo giá thành công!`
                });
                this.$emit('success');
                this.close();
            } else {
                const errMsg = (res && res.data && (res.data.reason || res.data.detail)) || 'Lỗi khi đọc file Excel';
                Vue.notify({
                    group: 'foo',
                    type: 'error',
                    title: 'Lỗi Import!',
                    text: errMsg
                });
            }
        } catch (e) {
            const err = e as any;
            const errText = (err && err.response && err.response.data && (err.response.data.reason || err.response.data.detail)) || (err && err.message) || 'Lỗi kết nối máy chủ';
            Vue.notify({
                group: 'foo',
                type: 'error',
                title: 'Lỗi hệ thống!',
                text: errText
            });
        } finally {
            this.isUploading = false;
            this.uploadProgress = false;
        }
    }
}
